import {Component, inject, signal, WritableSignal} from '@angular/core';
import {RepoService} from "../services/repo.service";
import {AdminPortalUser} from "../models/admin-portal-user";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-users-and-permissions',
  imports: [FormsModule],
  templateUrl: './users-and-permissions-page.component.html',
  styleUrl: './users-and-permissions-page.component.css',
  standalone: true
})
export class UsersAndPermissionsPage {

  repoService = inject(RepoService);
  users: WritableSignal<AdminPortalUser[]> = signal([]);

  accessOptions = [
    "Users and Permissions",
    "Statistics",
    "Health Check",
    "In-app message",
    "Site message",
    "Site Categories",
    "Charging prices",
    "RFID price",
    "Version history",
    "App rating",
    "Nps",
    "Migrate Sites"
  ];

  constructor() {
    this.repoService.getAllAdminPortalUsers().subscribe(users => {
      this.users.set(users);
    });
  }

  hasAccess(user: AdminPortalUser, option: string): boolean {
    return user.access.includes(option);
  }

  onAccessChange(user: AdminPortalUser, option: string, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    let updatedAccess = [...user.access];

    if (isChecked) {
      if (!updatedAccess.includes(option)) {
        updatedAccess.push(option);
      }
    } else {
      updatedAccess = updatedAccess.filter(item => item !== option);
    }

    this.repoService.updateAdminPortalUserAccess(user.id, updatedAccess)
      .then(() => {
        user.access = updatedAccess;
      })
      .catch(error => {
        console.error("Error updating user access:", error);
      });
  }
}
